import { X, ArrowRight, Trash2 } from 'lucide-react';
import { useCompare } from '@/context/CompareContext';

export const CompareBar = () => {
  const { compareList, removeFromCompare, clearCompare, openModal, maxCompare } = useCompare();

  if (compareList.length === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 compare-bar-gradient" data-testid="compare-bar">
      <div className="container-auto py-4">
        <div className="flex items-center justify-between gap-4">
          {/* Selected cars */}
          <div className="flex items-center gap-3 flex-1 overflow-x-auto pb-1 scrollbar-hide">
            {compareList.map((car) => (
              <div 
                key={car.id}
                className="compare-bar-item group"
                data-testid={`compare-item-${car.id}`}
              >
                <img 
                  src={car.images?.[0] || 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=100&h=60&fit=crop'}
                  alt={car.title}
                  className="w-16 h-10 object-cover rounded"
                />
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-medium text-white truncate max-w-[100px]">{car.title}</p>
                  <p className="text-xs text-gray-400">{car.year}</p>
                </div>
                <button
                  onClick={() => removeFromCompare(car.id)}
                  className="p-1 text-gray-400 hover:text-white transition-colors"
                  aria-label="Elimină din comparație"
                >
                  <X className="w-4 h-4" />
                </button>
              </div>
            ))}
            
            {/* Empty slots indicator */}
            {compareList.length < maxCompare && (
              <div className="compare-bar-empty">
                <span className="text-xs text-gray-500">+{maxCompare - compareList.length} mașini</span>
              </div>
            )}
          </div>

          {/* Actions */}
          <div className="flex items-center gap-3 shrink-0">
            <span className="text-sm text-gray-400 hidden sm:inline">
              {compareList.length}/{maxCompare}
            </span>
            
            <button
              onClick={clearCompare}
              className="p-2 text-gray-400 hover:text-white transition-colors"
              aria-label="Șterge toate"
            >
              <Trash2 className="w-5 h-5" />
            </button>

            <button
              onClick={openModal}
              disabled={compareList.length < 2}
              className="compare-btn-primary"
              data-testid="compare-button"
            >
              Compară
              <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
